"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtnLinkButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
const components_core_1 = require("@volkswagen-onehub/components-core");
const __1 = require("../..");
const BtnLinkButton = props => {
    const { btnLabel, btnAction, iconLabel } = props;
    return (react_1.default.createElement(styled_1.StyledFilterIconSection, { className: "button-link-container" },
        react_1.default.createElement(__1.DisableFocusWrapper, null,
            react_1.default.createElement(components_core_1.Text, { appearance: components_core_1.TokenTextAppearance.copy100, color: components_core_1.TokenTextColor.primary },
                react_1.default.createElement(__1.LinkButton, { onClick: btnAction },
                    react_1.default.createElement(styled_1.StyledIconWrapper, null,
                        iconLabel || react_1.default.createElement(__1.Menu, { variant: "small" }),
                        " ",
                        btnLabel))))));
};
exports.BtnLinkButton = BtnLinkButton;
